import axiosClient, { unwrap } from "./axiosClient";
import { ENDPOINTS } from "./endpoints";

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== ""
    )
  );

export const restaurantSettlementApi = {
  list: (businessDate) =>
      axiosClient
      .get(ENDPOINTS.restaurantCashSettlements.list, { params: cleanParams({ businessDate }) })
      .then(unwrap),

  confirm: (settlementId, note) =>
    axiosClient
      .post(ENDPOINTS.restaurantCashSettlements.confirm(settlementId), {
        note,
      })
      .then(unwrap),

  reject: (settlementId, reason) =>
    axiosClient
      .post(ENDPOINTS.restaurantCashSettlements.reject(settlementId), {
        reason,
      })
      .then(unwrap),

  current: (businessDate) =>
      axiosClient
      .get(ENDPOINTS.restaurantCashManagement.current, { params: cleanParams({ businessDate }) })
      .then(unwrap),

  expenses: ({ fromDate, toDate, search, businessDate } = {}) =>
    axiosClient
      .get(ENDPOINTS.restaurantCashManagement.expenses, {
        params: cleanParams({
          fromDate,
          toDate,
          search,
          businessDate,
        }),
      })
      .then(unwrap),

  addExpense: (data) =>
    axiosClient
      .post(ENDPOINTS.restaurantCashManagement.addExpense, data)
      .then(unwrap),

  voidExpense: (expenseId, reason) =>
    axiosClient
      .post(ENDPOINTS.restaurantCashManagement.voidExpense(expenseId), {
        reason,
      })
      .then(unwrap),

  ownerSettlements: (businessDate) =>
      axiosClient
      .get(ENDPOINTS.restaurantCashManagement.ownerSettlements, { params: cleanParams({ businessDate }) })
      .then(unwrap),

  requestOwnerSettlement: (data) =>
    axiosClient
      .post(ENDPOINTS.restaurantCashManagement.requestOwnerSettlement, data)
      .then(unwrap),
};
